import { MaterialMasterPage } from "./material-master-page"

export default function ClassificationSubCategoriesPage() {
  return (
    <MaterialMasterPage
      config={{
        title: "Classification Sub Categories",
        endpoint: "classification-subcategories",
        resource: "MaterialClassificationSubCategory",
        primaryLabel: "name",
        columns: [
          { key: "name", label: "Name" },
          { key: "category.name", label: "Category" },
          { key: "is_active", label: "Active" },
        ],
        fields: [
          { name: "category_id", label: "Classification Category", type: "select-search", optionsEndpoint: "classification-categories", optionLabelKey: "name", displayField: "category" },
          { name: "name", label: "Name", type: "text" },
          { name: "description", label: "Description", type: "textarea" },
          { name: "is_active", label: "Active", type: "checkbox" },
        ],
      }}
    />
  )
}
